import { render, staticRenderFns } from "./PersonalSpace.vue?vue&type=template&id=629e4ad4&scoped=true"
import script from "./PersonalSpace.vue?vue&type=script&lang=js"
export * from "./PersonalSpace.vue?vue&type=script&lang=js"
import style0 from "./PersonalSpace.vue?vue&type=style&index=0&id=629e4ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629e4ad4",
  null
  
)

export default component.exports